import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inputDateFormat'
})
export class InputDateFormatPipe implements PipeTransform {
  /**
   * Function to format inputDate from params, to latin format
   */
  public transform(value: string): string {
    const datePart = value.split('-');
    const year = datePart[0];
    const month = datePart[1];
    const day = datePart[2];
    return `${day}/${month}/${year}`;
  }
}
